import Cookies from "universal-cookie";

const cookies = new Cookies();

const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const handlerEmailSignUp = ({
  shopifyClient,
  email,
  checkoutID,
  handleUpdateCheckout,
  handleLoading,
  handleSuccess,
  handleError,
  sendgridList = ["2af4e6ae-6b52-4b5b-8e46-425d9dc5775d"],
  discountCode = undefined,
}) => {
  if (!email || !validateEmail(email)) {
    handleError();
    return;
  }
  cookies.set("email", email, { path: "/" });

  handleLoading();
  const headers = new Headers();
  headers.append(
    "Authorization",
    "Bearer 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"
  );
  headers.append("Content-Type", "application/json");
  const body = {
    list_ids: sendgridList,
    contacts: [
      {
        email: email,
      },
    ],
  };
  var request = new Request("https://api.sendgrid.com/v3/marketing/contacts", {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(body),
  });
  fetch(request)
    .then((response) => response.json())
    .then((data) => {
      if (checkoutID) {
        shopifyClient.checkout.updateEmail(checkoutID, email).then((co1) => {
          if (discountCode) {
            shopifyClient.checkout
              .addDiscount(checkoutID, discountCode)
              .then((co2) => {
                handleUpdateCheckout(co2);
                handleSuccess(true);
              });
          } else {
            // only email updated
            handleUpdateCheckout(co1);
            handleSuccess(true);
          }
        });
      } else {
        handleSuccess(true);
      }
    })
    .catch((e) => {
      handleError(true);
    });
};

export { validateEmail, handlerEmailSignUp };
